import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@fry/components/material';
import { UnboxedModule } from '@fry/ui';
import { UIBadgeModule } from '@fry/ui/badge';

import { TranslationFormComponent } from './translation-form/translation-form.component';
import { TranslationFormService } from './translation-form/translation-form.service';
import { TranslationFormStore } from './translation-form/translation-form.store';
import { TranslationSectionComponent } from './translation-section/translation-section.component';
import { TranslationSelectorComponent } from './translation-selector/translation-selector.component';
import { TranslationInfoListComponent } from './translation-info-list/translation-info-list.component';
import { QuillModule } from 'ngx-quill';


@NgModule({
  declarations: [
    TranslationFormComponent,
    TranslationSectionComponent,
    TranslationSelectorComponent,
    TranslationInfoListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    UnboxedModule,
    UIBadgeModule,
    QuillModule.forRoot({
      bounds: 'quill-editor', // or a different css selector, see DK-3247
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'align': [] }],
          ['link', 'image'],
          ['clean'],
        ]
      }
    }),
  ],
  exports: [
    TranslationInfoListComponent
  ],
  providers: [
    TranslationFormService,
    TranslationFormStore
  ]
})
export class TranslationEditorModule {

}
